import ScenarioFileUploadDialog from "@features/builder/UpdateMetadata/ScenarioFileUploadDialog"
import { MetadataFormValues } from "@features/builder/UpdateMetadata/validation"
import { CloudUpload, Delete } from "@mui/icons-material"
import { Button, IconButton, TextField, Tooltip } from "@mui/material"
import { getErrorMessage } from "@utils/form"
import { Controller, useFormContext } from "react-hook-form"
import { useSearchParams } from "react-router"

type ScenarioFileFieldProps = {
  onDelete: () => void
}

const ScenarioFileField = (props: ScenarioFileFieldProps) => {
  const form = useFormContext<MetadataFormValues>()
  const [searchParams, setSearchParams] = useSearchParams()
  const isUploadDialogOpen = searchParams.get("isUploadDialogOpen") === "true"

  const handleOpenUploadScenarioDialog = () => {
    setSearchParams((params) => {
      params.set("isUploadDialogOpen", true.toString())

      return params
    })
  }

  const handleCloseUploadScenarioDialog = () => {
    setSearchParams((params) => {
      params.delete("isUploadDialogOpen")

      return params
    })
  }

  return (
    <>
      <Controller
        name="scenario_source"
        control={form.control}
        render={({ field }) => {
          let textValue = ""

          if (typeof field.value === "string") textValue = field.value
          else if (field.value instanceof File) textValue = field.value.name

          if (textValue) {
            return (
              <TextField
                error={Boolean(form.formState.errors[field.name])}
                helperText={getErrorMessage(form.formState.errors, field.name)}
                label="Scenario source file"
                disabled
                InputLabelProps={{ disabled: false }}
                variant="standard"
                value={textValue}
                InputProps={{
                  endAdornment: (
                    <Tooltip title="Delete scenario source file">
                      <IconButton onClick={props.onDelete} color="error">
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  ),
                }}
              />
            )
          }

          return (
            <>
              {/* hidden input to not switch field state between controlled and uncontrolled */}
              <input
                name="scenario_source"
                value=""
                readOnly
                style={{ display: "none", width: 0, height: 0 }}
              />
              <Button
                component="label"
                variant="contained"
                startIcon={<CloudUpload />}
                onClick={handleOpenUploadScenarioDialog}
              >
                Upload scenario file
              </Button>
            </>
          )
        }}
      />

      {isUploadDialogOpen && <ScenarioFileUploadDialog onClose={handleCloseUploadScenarioDialog} />}
    </>
  )
}

export default ScenarioFileField
